import { AcAction, AcAirflow, AcMode } from '@pragma/interfaces';
import { IsInt, IsEnum, Min, Max } from 'class-validator';

export class AcActuationDTO {
    @IsInt()
    deviceId!: number;

    @IsEnum(AcAction)
    action!: AcAction;

    @IsEnum(AcMode)
    mode?: AcMode;

    @IsEnum(AcAirflow)
    airflow?: AcAirflow;

    @Min(16) // Assuming these temperature ranges are correct
    @Max(30)
    heatTemp?: number;

    @Min(16)
    @Max(30)
    coolTemp?: number;

    @IsInt()
    pairCode?: number;
}
